import React from 'react'
import Separator from '../../common/separator'
import SocialContact from '../../common/social-contact'
import './contact.css'

function Contact() {
    return (
        <div className='contact'>
            <Separator/>
            <label className='section-title'>Contact</label>
            <div className='contact-container'>
                <div className='contact-left'>
                    <p>Want to get in touch? Contact me on any of the platforms!</p>
                    <p className='email-text'>nipunaprs@gmail.com</p>
                    <SocialContact/>
                </div>
                <div className='download'>
                    <a download target="_blank" href="https://drive.google.com/file/d/1-jolt1Xo8-YSE7CZN2Etr0pns7wrgnyJ/view?usp=sharing">View Resume
                        <img src='/download.png' className='download-icon'></img>
                    </a>
                </div>
            </div>
            
        </div>
    )
}

export default Contact

